import {register} from 'dna-react-ioc'
import {UserGuideStoreSymbol} from '@/components'
import {TUserGuideStore} from '@/components/containers/UserGuideContainer/TUserGuideStore'
import {UserGuideStore} from '@/stores/user-guide/UserGuideStore'

export const userGuideInitState = () => {
    register<TUserGuideStore>(UserGuideStoreSymbol).to(UserGuideStore).inSingletonScope()
}
